import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ListItem from 'components/ListItem';
import {
  deletePayment,
  setPayment,
  setPaymentDecimalEdit,
  setPaymentEditIndex,
  setPaymentSelected,
  setShowPaymentInput,
} from 'actions/Payments';
import { getLastPayment, getPaymentsCurrency } from 'reducers/Payments';
import { useBreakpoints } from 'utils/hooks/UI';
import { useShortcut } from 'utils/hooks/keyboard/useShortcut';
import { KeyboardShortcut } from 'components/KeyboardShortcut';

const AddChangePayment = ({ disabled = false }) => {
  const { t } = useTranslation('payment');
  const dispatch = useDispatch();
  const isMobileView = !useBreakpoints().mdplus;
  const { lastPayment, lastKey } = useSelector(getLastPayment);
  const { code: currencyCode, rate } = useSelector(getPaymentsCurrency);

  const addChangePayment = () => {
    (async () => {
      await dispatch(setPaymentEditIndex(0));
      await dispatch(setPaymentDecimalEdit(false));

      if (lastPayment.amount === '0.00') {
        dispatch(deletePayment({ key: lastKey }));
      }

      await dispatch(
        setPayment({
          amount: '-0.00',
          key: `${currencyCode}-cash`,
          caption: t('tenders.change'),
          type: 'CHANGE',
          currencyCode,
          currencyRate: Number(rate),
        }),
      );
      await dispatch(setPaymentSelected(`${currencyCode}-cash`));
    })();
  };
  useShortcut('enterCash', addChangePayment, 20);

  return isMobileView ? (
    <li className="payment-item card-payment" style={{ cursor: 'pointer' }}>
      <div
        tabIndex={0}
        className="button"
        role="button"
        onClick={() => dispatch(setShowPaymentInput(true, 'CHANGE'))}
      >
        <span className="title">{t('buttons.enterChange')}</span>
      </div>
    </li>
  ) : (
    <ListItem
      disabled={disabled}
      // Despite this now being cash-withdrawal, test-id kept same to not ruin testing
      data-testid="cash-back-button"
      variant="grid_dark"
      action={addChangePayment}
    >
      <span className="cash-withdrawal">{t('buttons.change')}</span>
      <KeyboardShortcut className="func-key" shortcutAction="enterCash" />
    </ListItem>
  );
};

export default AddChangePayment;
